import React, { useEffect, useState, useMemo } from 'react';
import { Trophy, Gift, Lock, InstagramIcon, FacebookIcon } from 'lucide-react';
import Halwa from "../assets/Halwa.jpg";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Autocomplete,
  Typography,
  Box
} from "@mui/material";
import { createRazorPayOrder, getCoupons, verifyPayment } from '../service/network';
// import { useRazorpay, RazorpayOrderOptions } from "react-razorpay";
import { useRazorpay, RazorpayOrderOptions } from 'react-razorpay';
import CouponLeaf from './coupon/coupon';
import { getOutlets } from '../service/network';
import { auth } from '../firebase';
import AladiCoupon from './coupon/aaladiCoupon';
// const outlets = [
//   "Adyar", "Anna Nagar", "Besant Nagar", "Chromepet", "Tambaram",
//   "Velachery", "T Nagar", "Mylapore", "OMR", "Porur",
//   // ...add or fetch all 60
// ];

const slots = [
  {
    id: "first",
    label: "First",
    dates: "Oct 16",
  },
  {
    id: "second",
    label: "Second",
    dates: "Oct 17",
  },
  {
    id: "third",
    label: "Third",
    dates: "Oct 18",
  },
  {
    id: "four",
    label: "Four",
    dates: "Oct 19",
  },

];
export const LoyaltyRewards = () => {
  const currentSpent = 1278;
  const nextTierTarget = 7000;
  const progress = (currentSpent / nextTierTarget) * 100;
  const remainingAmount = nextTierTarget - currentSpent;

  const [open, setOpen] = useState(false);
  const [outlet, setOutlet] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const { error, isLoading, Razorpay } = useRazorpay();
  const [outlets, setOutlets] = useState([]);

  const [existing, setExisting] = useState([]);


  const { activeCoupons, redeemedCoupons, sortedCoupons } = useMemo(() => {
    let active = 0;
    let redeemed = 0;

    // sort so that: Paid & Active -> Redeemed -> everything else
    const sorted = [...existing].sort((a, b) => {
      const score = c => {
        if (c.Status === 1 && c.Paid === 1) return 2; // Active & paid
        if (c.Status === 2) return 1;                 // Redeemed
        return 0;                                     // Others
      };
      return score(b) - score(a);
    });

    existing.forEach(c => {
      if (c.Status === 1 && c.Paid === 1) active += 1;
      if (c.Status === 2) redeemed += 1;
    });

    return { activeCoupons: active, redeemedCoupons: redeemed, sortedCoupons: sorted };
  }, [existing]);

  const fetchCoupons = () => {
    getCoupons().then((resp) => {
      setExisting(resp.data);
    }).catch((err) => {
      console.log(err);
    })
  }


  const fetchOutlets = () => {
    getOutlets().then((resp) => {
      setOutlets(resp.data)
    }).catch((err) => {
      setOutlets([])
      console.log(err);
    })
  }

  useEffect(() => {
    fetchCoupons();
    fetchOutlets();
  }, []);

  const handleSubmit = () => {
    console.log({ outlet, selectedSlot });
    const user = auth.currentUser;
    // call Razorpay or next step
    setOpen(false);
    handlePayment({
      Phone: user.phoneNumber,
      Outlet: outlet.OutletName,
      Slot: selectedSlot
    })
  };


  const handlePayment = async (details) => {
    // 1. Create order on your backend
    const { data } = await createRazorPayOrder({
      Phone: details.mobile,
      Outlet: details.Outlet,
      Slot: details.Slot
    });
    const user = auth.currentUser;

    const options = {
      key: "rzp_live_RMGvxvCuZAese8",
      amount: data.amount,
      currency: data.currency,
      name: "Aaladipattiyan",
      description: "Diwali Pre-Booking Coupon",
      order_id: data.id,
      prefill: {
        name: user.displayName,
        email: user.email,
        contact: user.phoneNumber,
      },
      theme: { color: "#ea580c" }, // matches your orange theme
      handler: function (response) {
        // response.razorpay_payment_id, response.razorpay_order_id, response.razorpay_signature
        // Verify on backend
        verifyPayment(response)
          .then(() => {
            alert("Payment successful!");
            fetchCoupons();
            setOutlet(null);
            setSelectedSlot(null);
          }).catch(() => alert("Payment Verification failed. Please check the dashboard for the latest updates."));
      },
    };

    const rzp = new Razorpay(options);
    rzp.open();
  };


  const tiers = [
    {
      name: 'Bronze',
      icon: Trophy,
      reward: '10% Aaladipattiyan Coins on every purchase',
      range: '₹0 - ₹7000',
      isUnlocked: true,
      isActive: true
    },
    {
      name: 'Silver',
      icon: Gift,
      reward: '15% Aaladipattiyan Coins on every purchase',
      range: '₹7001 - ₹12000',
      isUnlocked: false,
      isActive: false
    },
    {
      name: 'Gold',
      icon: Trophy,
      reward: '20% Aladipattiyan Coins on every purchase',
      range: '₹12001 and upward',
      isUnlocked: false,
      isActive: false
    }
  ];

  if (isLoading) {
    // return (
    //   <div className="flex items-center justify-center h-screen">
    //     <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500"></div>
    //   </div>
    // );
  }

  return (
    <div className="mx-4 mt-6">
      <div className="bg-green-50 rounded-2xl p-4 mb-6 text-center border border-green-200">
        <p className="text-green-700 font-semibold">
          Pre-book now for {' '}
          <span className="text-red-900 font-bold text-lg">₹99/-</span>{' '}. Pay{' '}
          <span className="text-red-900 font-bold text-lg">₹449/-</span>{' '}
          during pickup. Get sweets worth  {' '}
          <span className="text-red-900 font-bold text-lg">₹550/-</span>{' '} + {' '}
          <span className="text-yellow-500 font-bold text-lg">FREE Halwa worth ₹130!</span>{' '}
        </p>
      </div>




      <div className="relative mx-auto mb-6 bg-rose-700 shadow-lg rounded-2xl overflow-hidden flex items-center justify-center p-6">
        {/* Large cracker image – top-left */}
        <img
          src={require("../assets/cracker.png")}
          alt="Large Cracker"
          className="absolute top-0 left-0 w-25 h-25 object-contain opacity-50"
        />

        {/* Small cracker image – bottom-right */}
        <img
          src={require("../assets/cracker.png")}
          alt="Small Cracker"
          className="absolute bottom-0 right-0 w-20 h-20 object-contain opacity-50"
        />

        {/* Center Text & Button */}
        <div className="relative flex flex-col items-center text-center">
          <p className="text-white font-semibold text-lg md:text-xl">
            Celebrate this Diwali with Aaladipattiyan's
          </p>
          <p className="text-yellow-400 font-extrabold text-2xl md:text-4xl mt-2 drop-shadow-lg">
            Festive Sweets Combo
          </p>
          <button
            disabled
            className="mt-4 bg-yellow-400 text-rose-700 text-sm font-semibold px-6 py-2 rounded-full shadow"
            onClick={() => setOpen(true)}
          >
            Pre-book Now @ ₹99
          </button>
        </div>
      </div>


      <div className="mx-auto mb-6 bg-white shadow-lg rounded-2xl overflow-hidden flex flex-col md:flex-row">
        {/* Product Image (Top on mobile) */}
        <div className="md:w-1/2">
          <img
            src={require("../assets/TreatBox.jpg")}
            alt="Product"
            className="w-full h-64 md:h-full object-cover"
          />
        </div>

        {/* Separator (only visible on desktop) */}
        <div className="hidden md:block w-px bg-gradient-to-b from-yellow-400 via-yellow-500 to-yellow-400"></div>

        {/* Product Content */}
        <div className="bg-rose-700 md:w-1/2 p-4 flex flex-col items-center">
          <div className="text-center mb-4">
            <p className="text-2xl text-white font-extrabold">
              FESTIVE SWEETS COMBO
            </p>
          </div>

          <ul className="text-yellow-400 text-sm font-medium space-y-1 leading-snug list-disc list-inside">
            <li>Srivillipuththur Palkova</li>
            <li>Kaju Katli</li>
            <li>Athirasam</li>
            <li>Badam Soan Papdi</li>
            <li>Ghee Laddu</li>
            <li>Mothi Laddu</li>
            <li>Spl Laddu</li>
            <li>Aaladi Mysore Pak</li>
            <li>Ghee Mysore Pak</li>
            <li>Nattusakkarai Badusha</li>
            <li>Ghee Murukku</li>
            <li>Rose Bites</li>
            <li>Assorted Bites</li>
          </ul>
          <div className="text-center mt-4">
            <p className="text-xl text-white font-extrabold">
              FREE ¼ KILO <br /> TIRUNELVELI GHEE HALWA
            </p>
          </div>

          {/* Net weight + Button */}
          <div className="bg-blue-50 rounded-2xl p-4 mt-6 border border-blue-200 flex items-center justify-between w-full max-w-xs">
            <p className="text-blue-700 font-semibold text-sm md:text-base text-center md:text-center">
              Net weight: 850gm <br /> + Free 250gm
            </p>
            <button
              disabled
              className="ml-4 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-4 py-2 rounded-full shadow"
              onClick={() => setOpen(true)}>
              Pre-book Now @ ₹99
            </button>
          </div>
        </div>


      </div>

      <div className="bg-yellow-400 rounded-2xl p-4 mb-6 text-center border border-yellow-400">
        <p className="text-rose-900 font-semibold">
          முன்பணம் ₹99 செலுத்துங்கள்… பிக்கப் செய்யும் போது ₹449 மட்டும் செலுத்தி, ₹550 மதிப்புள்ள Festive Sweets Combo மற்றும் 250 கிராம் - ரூபாய் ₹130 மதிப்புள்ள திருநெல்வேலி நெய் அல்வா இலவசமாக பெறுங்கள்!
        </p>
      </div>

      <div className="bg-yellow-400 mb-6 rounded-2xl p-4 mb-6 border border-yellow-400">
        <h2 className="font-bold underline mb-1 text-xs">நிபந்தனைகள்</h2>
        <ul className="list-disc text-rose-900 list-inside text-[11px] space-y-2 leading-relaxed">
          <li>
            கூப்பன் 16 அக்டோபர் 2025 முதல் 19 அக்டோபர் 2025 வரை மட்டுமே
            செல்லுபடியாகும்.
          </li>
          {/* <li>இந்த கூப்பனை ஆன்லைனில் பயன்படுத்த முடியாது.</li> */}
          <li>
            தேர்ந்தெடுத்த கடைகளில், தேர்ந்தெடுத்த நாட்களில் மட்டுமே இந்த
            கூப்பனை பயன்படுத்த முடியும்.
          </li>
          <li>
            இந்த கூப்பன் பணத்தைத் திருப்பித் தர இயலாது மற்றும் மாற்றிக்கொள்ள இயலாது.
          </li>
        </ul>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
        {/* Active Coupons */}
        <div className="bg-green-50 rounded-2xl p-4 text-center border border-green-200">
          <p className="text-green-700 font-semibold text-lg">
            Active Coupons
          </p>
          <p className="text-2xl font-bold text-green-800 mt-1">
            {activeCoupons}
          </p>
        </div>

        {/* Redeemed Coupons */}
        <div className="bg-blue-50 rounded-2xl p-4 text-center border border-blue-200">
          <p className="text-blue-700 font-semibold text-lg">
            Redeemed Coupons
          </p>
          <p className="text-2xl font-bold text-blue-800 mt-1">
            {redeemedCoupons}
          </p>
        </div>
      </div>



      <div className="space-y-4">
        <div className="space-y-4">
        </div>

        <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xs">
          <DialogTitle>Pickup Details</DialogTitle>
          <DialogContent dividers>
            {/* Outlet selection */}
            <Autocomplete
              options={outlets}
              value={outlet}
              getOptionLabel={option => option.OutletName}
              disableClearable
              onChange={(e, val) => setOutlet(val)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Destination Outlet"
                  placeholder="Start typing outlet name"
                  margin="normal"
                  fullWidth
                />
              )}
            />
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
              <a
                href="https://halwakadai.com/outlets"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#1976d2',
                  textDecoration: 'underline',
                  fontWeight: '500',
                  fontSize: "14px"
                }}
              >
                View All Outlets
              </a>

            </Box>
            {/* Pickup Slot selection */}
            <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
              Select Pickup Slot
            </Typography>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
              {slots.map((slot) => (
                <Box
                  key={slot.id}
                  onClick={() => setSelectedSlot(slot)}
                  sx={{
                    flex: "1 1 45%",
                    p: 2,
                    border: "2px solid",
                    borderColor:
                      selectedSlot?.id === slot.id ? "orange.main" : "grey.300",
                    borderRadius: 3,
                    cursor: "pointer",
                    textAlign: "center",
                    bgcolor:
                      selectedSlot?.id === slot.id ? "orange.50" : "background.paper",
                    transition: "0.2s",
                    "&:hover": { borderColor: "orange.main" },
                  }}
                >
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.primary"
                  >
                    {slot.label}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 0.5 }}
                  >
                    {slot.dates}
                  </Typography>
                </Box>
              ))}
            </Box>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              disabled={!outlet || !selectedSlot}
              onClick={handleSubmit}
            >
              Confirm & Pay
            </Button>
          </DialogActions>
        </Dialog>

        {
          sortedCoupons.map((ele, ind) =>
            <AladiCoupon
              couponData={ele}
            />)
        }




        {/* {tiers.map((tier) => (
          <div
            key={tier.name}
            className={`rounded-2xl p-6 shadow-lg border transition-all duration-200 hover:shadow-xl ${
              tier.isActive
                ? 'bg-white border-green-200'
                : tier.isUnlocked
                ? 'bg-gray-50 border-gray-200'
                : 'bg-gray-100 border-gray-300'
            }`}
          >
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className={`p-2 rounded-full ${
                  tier.isActive
                    ? 'bg-yellow-100'
                    : tier.isUnlocked
                    ? 'bg-gray-200'
                    : 'bg-gray-300'
                }`}>
                  <tier.icon size={20} className={
                    tier.isActive
                      ? 'text-yellow-600'
                      : tier.isUnlocked
                      ? 'text-gray-600'
                      : 'text-gray-500'
                  } />
                </div>
                <h3 className={`text-xl font-bold ${
                  tier.isActive ? 'text-gray-900' : 'text-gray-600'
                }`}>
                  {tier.name}
                </h3>
              </div>
              {!tier.isUnlocked && (
                <Lock size={20} className="text-gray-400" />
              )}
            </div>

            <div className="flex items-center gap-3 mb-4">
              <Gift size={16} className="text-purple-600" />
              <p className="text-gray-700 font-medium">{tier.reward}</p>
            </div>

            {tier.isActive && (
              <>
                <div className="flex justify-between items-center mb-2">
                  <span className="text-sm font-medium text-gray-600">₹0</span>
                  <span className="text-sm font-medium text-gray-600">₹{nextTierTarget} total spent</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-3 mb-3">
                  <div
                    className="bg-gradient-to-r from-green-500 to-green-600 h-3 rounded-full transition-all duration-500"
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>
                <p className="text-sm text-gray-600 mb-1">
                  You've spent ₹{currentSpent} till now.
                </p>
                <p className="text-sm font-semibold text-gray-800">
                  You're ₹{remainingAmount} away for silver level
                </p>
              </>
            )}

            {!tier.isActive && tier.range && (
              <p className="text-sm text-gray-600 font-medium">{tier.range}</p>
            )}
          </div>
        ))} */}
      </div>
    </div>
  );
};